import { createFileRoute } from '@tanstack/react-router'
import { BotDetectionEventDetailsPage } from 'features/botDetection/components/BotDetectionEventDetailsPage'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/bot-detection/events/$eventId'
)({
  component: BotDetectionEventDetailsPage,
})
